import http from './cart/http.service';

export const dashboardService = {
    traerDashboard
};

/**
 * Todo el panel de estadísticas en una sola llamada.
 *
 * <p>Una sola y no una por bloque: son diez consultas agregadas que corren en milisegundos del lado
 * del server, y partirlas haría que la pantalla se dibuje de a pedazos y que mover el selector de
 * período dispare diez pedidos en paralelo.
 *
 * @param dias ventana de los números gruesos y de los rankings. La serie mensual del gráfico siempre
 *             va a doce meses, sin importar este valor.
 */
function traerDashboard(dias = 30) {
    return http.get(`/api/vendedor/dashboard/data?dias=${dias}`);
}
